import { render, staticRenderFns } from "./UserPopup.vue?vue&type=template&id=000b3209&scoped=true"
import script from "./UserPopup.vue?vue&type=script&lang=js"
export * from "./UserPopup.vue?vue&type=script&lang=js"
import style0 from "./UserPopup.vue?vue&type=style&index=0&id=000b3209&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b3209",
  null
  
)

export default component.exports